import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { StoreService } from 'src/app/store.service';
import { Subscription } from 'rxjs';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UtilitiesService} from 'src/app/core/utilities.service';

@Component({
  selector: 'app-add-discount',
  templateUrl: './add-discount.component.html',
  styleUrls: ['./add-discount.component.scss']
})
export class AddDiscountComponent implements OnInit {

  store_id = 1;
  bearer;
  selectedVoucer = '';
  selectedVoucerId;
  
  voucherList: any;
  discounts : any;
  discount_id =[];

  promotionForm!: FormGroup;
  promotion: any;
  formError = false;
	itemValidation: any = [false,false];

  // discountList: any;

  closeResult = '';
  success;
  updateSuccess = false;

  country_code: any;
  clickEventsubscription: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    private storeService: StoreService,
    private modalService: NgbModal,
    private router: Router,
    private utils: UtilitiesService,
  ) {
    // Change store_id accordingly
    this.clickEventsubscription = storeService.getClickEvent().subscribe(()=>{
      const store_id = localStorage.getItem('store_id');
      if(store_id) {
        this.store_id = parseInt(store_id);
      }
    })
  }

  ngOnInit(): void {
    // Change store_id
    const store_id = localStorage.getItem('store_id');
    this.bearer = localStorage.getItem('bearer');
    if(store_id) {
      this.store_id = parseInt(store_id);
    }

    this.getDiscountList();
    this.getStoreDiscount();
  }

  getDiscountList(){
    this.storeService.getDiscountList(this.store_id, this.bearer).subscribe(res2=>{
      this.voucherList = Object.keys(res2['data']).map(index2 => {
        let discList = res2['data'][index2];
        // this.discount_id.push(discList['p_id']);
        return discList;
     });
     console.log("list",this.voucherList);
     if (this.voucherList.length == 0) {
      setTimeout(()=>{
        this.router.navigate(['/dashboard/discounts']);
      },2000)
       
     }
    })
  }

  getStoreDiscount() {
    this.storeService.getStoreDiscount(this.store_id,this.bearer).subscribe(res=>{
      // this.discounts = res['data'];
      this.discounts = Object.keys(res['data']).map(index => {
        let disc = res['data'][index];
        // console.log(disc['p_id']);
        this.discount_id.push(disc['p_id']);
        return disc;
    });
    },(err)=>{
      this.discounts = [];
    })
  }

  selectVoucher(voucher: string, p_id: number) {
    this.selectedVoucer = voucher;
    this.selectedVoucerId = p_id;
  }

  addDiscount(id: number) {

    if (!id)
        return;

    this.updateSuccess = true;
    this.discount_id.push(id);
    const params = {
      store_id:this.store_id.toString(),
      discount_id:this.discount_id
    };

    this.storeService.updateStoreDiscount(params, this.bearer).subscribe(res=>{
      console.log(res);
      console.log("storeservice",this.storeService.updateStoreDiscount);
      this.getDiscountList();
      this.selectedVoucer = '';
      this.selectedVoucerId = '';
      
      this.utils.notify.showSuccess(this.utils.translate("Discount added successfully!"));

    },(err)=>{
        this.getDiscountList();
        this.selectedVoucer = '';
        this.selectedVoucerId = '';
    })
  }

  successModal(success) {
      if (!this.updateSuccess) {
          return;
      }
      this.updateSuccess = false;
      this.modalService.open(
          success, {
              ariaLabelledBy: 'modal-basic-title',
              size: 'sm',
              windowClass: 'modal-success',
              centered: true,
              backdrop: 'static'
          }).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
          // location.reload();
          this.modalService.dismissAll();

      }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          //location.reload();
          this.modalService.dismissAll();
      });
      //location.reload();
  }

  private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
          return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          return 'by clicking on a backdrop';
      } else {
          return `with: ${reason}`;
      }
  }

  backToList() {
      this.router.navigate(['/dashboard/discounts']);
  }
}
